import { render, staticRenderFns } from "./OtpView.vue?vue&type=template&id=0c630cbc&scoped=true"
import script from "./OtpView.vue?vue&type=script&lang=js"
export * from "./OtpView.vue?vue&type=script&lang=js"
import style0 from "./OtpView.vue?vue&type=style&index=0&id=0c630cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c630cbc",
  null
  
)

export default component.exports